import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { Button, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { common } from "@mui/material/colors";
import { useAuth } from "AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "static/qca-white.png";
import { AppContext } from "AppContext";
import { ActionTypes } from "reducer/actions";
import { DashboardKeys, BreastTechnicalAppendixUrl, BrainTechnicalAppendixUrl, CrcTechnicalAppendixUrl, HeadAndNeckTechnicalAppendixUrl, AMLTechnicalAppendixUrl /*, LungTechnicalAppendixUrl*/ } from "config/appUrlConfig";


function Header() {
	let navigate = useNavigate();
	let location = useLocation();

	let openTechnicalAppendix = (currentPageKey: string) => {
		let route = location.pathname;

		if (currentPageKey == "/breast-indicators") {
			route = BreastTechnicalAppendixUrl;
		} else if (currentPageKey == "/crc-indicators") {
			route = CrcTechnicalAppendixUrl;
		}
		// else if (currentPageKey == "/lung-indicators") {
		// 	route = LungTechnicalAppendixUrl;
		// } 
		else if (currentPageKey == "/brain-indicators") {
			route = BrainTechnicalAppendixUrl;
		}
		else if (currentPageKey == "/headandneck-indicators") {
			route = HeadAndNeckTechnicalAppendixUrl;
		}
		else if (currentPageKey == "/aml-indicators") {
			route = AMLTechnicalAppendixUrl;
		}

		window.open(route, "_blank");
	}

	const { state, dispatch } = React.useContext(AppContext);

	/*
		Add elements to dashboard keys to make navigation buttons visible
	*/
	const dashboards = DashboardKeys();

	const isHomeRoute = location.pathname == "/mdt-activity" || location.pathname == "/";


	const navButton = (key: string, label: string, pathToNavigateTo: string) => {
		const dash: boolean = dashboards[key];

		if (dash == undefined || !dash)
			return;

		let style = {
			color: "white",
			marginTop: 10,
			marginLeft: 5
		}

		const currentRoute = pathToNavigateTo == location.pathname || (pathToNavigateTo == "/mdt-activity" && location.pathname == "/")

		if (currentRoute)
			style = Object.assign({}, style, { textDecoration: "underline", textUnderlineOffset: "100%" });

		return (
			<Button
				color="inherit"
				key={`navButton_${pathToNavigateTo}`}
				style={style}
				onClick={() => {
					if (!currentRoute) {
						if (!state.page.loading) {
							dispatch({ type: ActionTypes.UserWantsToNavigate })
							navigate(pathToNavigateTo)
						}
					}
				}

				}
			>
				{label}
			</Button>
		)
	}



	return (
		<Box>
			<AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
				<Toolbar sx={{ justifyContent: "space-between" }}>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<img
							src={logo}
							alt="Cancer Alliance Queensland"
							width={180}
							onClick={() => {
								if (!isHomeRoute) {
									if (!state.page.loading) {
										dispatch({ type: ActionTypes.UserWantsToNavigate })
										navigate("/");
									}
								}
							}}
						/>
						<Box>
							<Typography sx={{ marginLeft: 5 }} variant="subtitle1">
								<>
									{navButton("mdt", "MDT Activity", "/mdt-activity")}
									{navButton("noMdt", "Treatment Activity", "/treatment-activity")}
									{navButton("breast", "Breast", "/breast-indicators")}
									{navButton("crc", "Colorectal", "/crc-indicators")}
									{navButton("lung", "Lung", "/lung-indicators")}
									{navButton("brain", "Brain", "/brain-indicators")}
									{navButton("headAndNeck", "Head And Neck", "/headandneck-indicators")}
									{navButton("aml", "AML", "/aml-indicators")}
									{navButton("youthCancer", "Youth Cancer", "/youthcancer-indicators")}
								</>
							</Typography>
						</Box>
					</Box>
					<Box>
						{(location.pathname == "/mdt-activity" || location.pathname == "/lung-indicators" || location.pathname == "/" ? <></> : <Button
							color="inherit"
							key={`navButton_${location.pathname}_TechnicalAppendix`}
							style={{
								color: "white",
								// marginTop:10,
								// marginLeft: 5
							}}
							onClick={() => {
								openTechnicalAppendix(location.pathname);
							}}
						>
							Technical Appendix
						</Button>
						)}
						<Ellipsis
							showInternalLinks={state.appSettings.showInternalLinks}
							qlikLink={state.userSettings.qlikLink}
							qoolLink={state.userSettings.qoolLink}
						/>
						<Account />
					</Box>
				</Toolbar>
			</AppBar>
		</Box>
	)
}


function Account() {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	let auth = useAuth();

	if (!auth.user)
		return null;

	return (
		<>
			<IconButton onClick={handleClick}>
				<PersonIcon sx={{ color: common.white }} />
			</IconButton>
			<Menu
				open={open}
				onClose={handleClose}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
			>
				<MenuItem onClick={auth.signout}>Logout</MenuItem>
			</Menu>
		</>
	)
}



function Ellipsis(props: { showInternalLinks: boolean, qlikLink: string, qoolLink: string }) {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const openLink = (link: string) => {
		window.open(link, '_blank').focus();
	}

	return (
		<>
			<IconButton onClick={handleClick}>
				<MoreVertIcon sx={{ color: common.white }} />
			</IconButton>
			<Menu
				open={open}
				onClose={handleClose}
				style={{ marginTop: 5 }}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				{props.qoolLink && <MenuItem onClick={() => openLink(props.qoolLink)}>Open QOOL</MenuItem>}
				{props.showInternalLinks && props.qlikLink && <MenuItem onClick={() => openLink(props.qlikLink)}>Open QLIK-Dash</MenuItem>}
			</Menu>
		</>
	)
}

export default Header;